import React from 'react'
import ContactForm from './ContactForm'
import { Link } from 'react-router-dom';


const Contact = () => {
  return (
    <div>
      

      <>
  <style
    dangerouslySetInnerHTML={{
      __html:
        "\n    @media only screen and (max-width: 499px) {\n        .contact-section .tab-btns li {\n            width: 40% !important;\n            \n        }\n    }\n"
    }}
  />
<section className="page-title centred">
            <div className="bg-layer" style={{ backgroundImage: `url(assets/img/bg-img.png)` }}></div>
            <div className="line-box">
                <div className="line-1"></div>
                <div className="line-2"></div>
            </div>
            <div className="auto-container">
                <div className="content-box">
                    <h1>Get in Touch</h1>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li>Contact</li>
                    </ul>
                </div>
            </div>
        </section>

        <section className="contact-info-section centred">
            <div className="auto-container">
                <div className="title-box">
                    <div className="icon-box"><i className="flaticon-headphones"></i></div>
                    <h2>Need Support? Talk with SNKB</h2>
                    {/* <h3><Link to="tel:+919930400377">(+91) 99304 00377 </Link></h3> */}
                </div>
                <div className="inner-container">
                    <div className="row clearfix">
                        <div className="col-lg-4 col-md-6 col-sm-12 info-column">
                            <div className="info-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-mail"></i></div>
                                    <h3>Send Mail</h3>
                                    <p><span> </span> <Link to="mailto:info@snkbbearings.com">info@snkbbearings.com</Link></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 info-column">
                            <div className="info-block-one">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-pin"></i></div>
                                    <h3>Our Presence</h3>
                                    <p><b>SNKB BEARINGS</b>
                                    <br />109 Swastik Disa Corporate Park,<br/> LBS Rd, Nityanand Nagar,<br/> Ghatkopar West, Mumbai
                                    </p>
                                </div>
                            </div>
                        </div>
                     
                        <div className="col-lg-4 col-md-6 col-sm-12 info-column">
    <div className="info-block-one">
        <div className="inner-box">
        <div className="icon-box"><i className="flaticon-headphones"></i></div>
            <h3>Mobile No</h3>
            <p><Link to="tel:+919930400377"><i className="flaticon-phone-call"></i>+91 99304 00377</Link></p>
        </div>
    </div>
</div> 

                    </div>
                </div>
            </div>
        </section>




        <section className="contact-section sec-pad border-top border-bottom bg-color-1">
  <div className="outer-container">
    <div className="tabs-content">
      <div className="tab active-tab" id="tab-1">
        <div className="row clearfix">
          <div className="col-lg-12 col-md-12 col-sm-12 map-column">
            <div className="map-inner">
              <div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1885.150355091099!2d72.9115733910749!3d19.094459472647504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c7cc272e9c3d%3A0xe5e21bf9a8537327!2sSwastik%20Disa%20Business%20park!5e0!3m2!1sen!2sin!4v1709707725850!5m2!1sen!2sin"
                  width="100%"
                  height={450}
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div className="auto-container">
      <div className="sec-title centred">
        <span className="sub-title">Branch Office</span>
        <h2>SNKB Branch Office</h2>
      </div>
    </div>
    <style
      dangerouslySetInnerHTML={{
        __html:
          "\n                .contact-section .tab-btns li {\n                    cursor: default !important;\n                }\n                .contact-section .tab-btns li:before {\n                    font-size: 0px;\n                }\n                .sec-pad {\n    padding: 47px 0px 47px 0px;\n}\n            "
      }}
    />
    <div className="tabs-box">
      <div className="tab-btn-box">
        <div className="auto-container">
          <ul className="tab-btns  clearfix">
            <li>Mumbai</li>
            <li>Surat</li>
            <li>Bhavnagar</li>
            <li>Ahmedabad</li>
            <li>Vadodara</li>
            <li>Nashik</li>
            <li>Nagpur</li>
            <li>Tamilnadu</li>
            <li>Vapi</li>
            <li>Gandhidham</li>
            <li>Raipur</li>
            <li>Madhyapradesh</li>
            <li>Uttar Pradesh</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
{/* contact-section end */}
<section
  className="contact-info-section centred"
  style={{ paddingTop: 100, paddingBottom: 30 }}
>
  <div className="auto-container">
    <div className="sec-title centred">
      <span className="sub-title">Our Dealers</span>
      <h2>Our Authorised Dealers</h2>
    </div>
    <div className="section-content">
      <div className="row no-gutters">
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/unique-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/balaji-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/hind-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/ibs-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/real-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
        <div className="col-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
          <div className="sponsor-card">
            <img
              src="assets/images/brand/Deal/shivraj-b.png"
              alt="image"
              className="custom-sponsor-img"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ContactForm></ContactForm>

</>



    </div>
  )
}

export default Contact
